import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import {FormFieldBase } from '../../models/form-field-base';

@Component({
  selector: 'dynamic-form-field',
  templateUrl: './dynamic-form-field.component.html',
  styleUrls: ['./dynamic-form-field.component.css']
})
export class DynamicFormFieldComponent implements OnInit {
  @Input() question!: FormFieldBase;
  @Input() form!: FormGroup;
  @Output() onChangeValue = new EventEmitter<{ key: string, event: any }>();
  value: string;
  chipsValue: string[] = [];


  ngOnInit(): void {
    if(this.question.chips == null) {
      this.question.chips = true;
    }
    if (this.question?.controlType === 'chips' && Array.isArray(this.question.value)) {
      this.chipsValue = this.question.value;
    }
  }

  emit(event: { key: string, event: any }) {
    if(event.event === 'null'){
      event.event = undefined;
    }
    this.onChangeValue.emit({ key: event.key, event: event.event });
  }

  hasError(key: string): boolean {
    const control = this.form.get(key);
    if (control) {
      return !!control.errors;
    }
    return false;
  }

  getErrors(key: string): string {
    const control: AbstractControl = this.form.get(key);
    let value = '';
    if (control.errors) {
      // Cicla attraverso gli errori del controllo
      Object.keys(control.errors).forEach((errorKey: string) => {
        const errorValue = control.errors[errorKey];
        if (errorKey === 'required') {
          value = value.concat(" , ", '');
        } else
        if (errorValue.message) {
          value = value.concat(" , ", errorValue.message);
        } else {
          value = value.concat(" , ", errorKey);
        }
        if (value.startsWith(' , ')) {
          value = value.slice(2);
        }
      });
    }
    const errorKey = value.trim();
    if (this.question.errors && this.question.errors[errorKey]) {
      value = this.question.errors[errorKey];
    }
    return value;
  }
  isDisabled(): boolean {
    if(this.question.disabled === undefined || this.question.disabled === null) return false;
    return this.question.disabled;
  }
  onMultySelect(event: { key: string, event: any }) {
    this.onChangeValue.emit({ key: event.key, event: event.event.value })
  }

  onChipsAdd(value: string){
    if(!this.chipsValue.some( s => s == value))
      this.chipsValue.push(value);
  }

  onChipsRemove(value: string){
    this.chipsValue = this.chipsValue.filter(s => s != value);
  }

  onChipsClear(){
    this.chipsValue = [];
  }

  onChipsBlur(){
    this.emit({key: this.question.key, event: this.chipsValue});
  }


}
